import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledCreateRequest } from './create-request.styled';

export const CreateRequest = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => {
  return (
    <StyledCreateRequest {...props}>
      <FontAwesomeIcon icon={faPlus} />
      <span>Create a Request</span>
    </StyledCreateRequest>
  );
};
